export const CountryCode = Object.freeze({
  BHR: "BHR",
  IND: "IND",
  KWT: "KWT",
  QAT: "QAT",
  OMN: "OMN",
  SAU: "SAU",
  ARE: "ARE",
  USA: "USA",
});

export const CurrencyCode = Object.freeze({
  BHD: "BHD",
  INR: "INR",
  KWD: "KWD",
  QAR: "QAR",
  OMR: "OMR",
  SAR: "SAR",
  AED: "AED",
  USD: "USD",
});

export const IsdCode = Object.freeze({
  BAHRAIN: "+973",
  INDIA: "+91",
  KUWAIT: "+965",
  QATAR: "+974",
  OMAN: "+968",
  SAUDI_ARABIA: "+966",
  UAE: "+971",
  USA: "+1",
});

export const LocaleCode = Object.freeze({
  EN_IN: "en-IN",
  EN_US: "en-US",
});

export const StorageKey = Object.freeze({
  SELECTED_COUNTRY: "selectedCountry",
});

export const DISPLAY_PLACEHOLDER = "—";
